import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { signalFonts } from '@/theme/foundations/tokens';

export interface AvatarPerson {
  /** Initials, or an overflow marker like "+2". */
  initials: string;
  bg: string;
  fg: string;
}

interface InitialsAvatarProps extends Partial<AvatarPerson> {
  size?: number;
  /** Ring color, used when avatars overlap a card surface. */
  ring?: string;
  ringWidth?: number;
  sx?: SxProps<Theme>;
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  initials = '',
  bg,
  fg,
  size = 26,
  ring,
  ringWidth = 2,
  sx,
}) => (
  <Box
    component="span"
    sx={{
      width: size,
      height: size,
      flex: 'none',
      borderRadius: '999px',
      background: bg,
      color: fg,
      fontFamily: signalFonts.ui,
      fontWeight: 700,
      // Initials scale with the circle so "+2" never overflows a 20px avatar.
      fontSize: `${Math.max(9, Math.round(size * 0.38))}px`,
      lineHeight: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: ring ? `${ringWidth}px solid ${ring}` : 0,
      ...sx,
    }}
  >
    {initials}
  </Box>
);

export default InitialsAvatar;
